import React from "react";
import { IconProps, iconPropTypes } from "./IconProps";

const ShareIcon: React.FC<IconProps> = ({
  fill = "",
  width = 32,
  height = 32,
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 14 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.25 5C13.25 5.19891 13.171 5.38968 13.0303 5.53033C12.8897 5.67098 12.6989 5.75 12.5 5.75C12.3011 5.75 12.1103 5.67098 11.9697 5.53033C11.829 5.38968 11.75 5.19891 11.75 5V2.8125L8.03063 6.53187C7.88973 6.67277 7.69863 6.75193 7.49938 6.75193C7.30012 6.75193 7.10902 6.67277 6.96812 6.53187C6.82723 6.39098 6.74807 6.19988 6.74807 6.00063C6.74807 5.80137 6.82723 5.61027 6.96812 5.46938L10.6875 1.75H8.5C8.30109 1.75 8.11032 1.67098 7.96967 1.53033C7.82902 1.38968 7.75 1.19891 7.75 1C7.75 0.801088 7.82902 0.610322 7.96967 0.46967C8.11032 0.329018 8.30109 0.25 8.5 0.25H12.5C12.6989 0.25 12.8897 0.329018 13.0303 0.46967C13.171 0.610322 13.25 0.801088 13.25 1V5ZM10.5 6.5C10.3011 6.5 10.1103 6.57902 9.96967 6.71967C9.82902 6.86032 9.75 7.05109 9.75 7.25V11.25H2.25V3.75H6.25C6.44891 3.75 6.63968 3.67098 6.78033 3.53033C6.92098 3.38968 7 3.19891 7 3C7 2.80109 6.92098 2.61032 6.78033 2.46967C6.63968 2.32902 6.44891 2.25 6.25 2.25H2C1.66848 2.25 1.35054 2.3817 1.11612 2.61612C0.881696 2.85054 0.75 3.16848 0.75 3.5V11.5C0.75 11.8315 0.881696 12.1495 1.11612 12.3839C1.35054 12.6183 1.66848 12.75 2 12.75H10C10.3315 12.75 10.6495 12.6183 10.8839 12.3839C11.1183 12.1495 11.25 11.8315 11.25 11.5V7.25C11.25 7.05109 11.171 6.86032 11.0303 6.71967C10.8897 6.57902 10.6989 6.5 10.5 6.5Z"
      fill="#287BB9"
    />
  </svg>
);

ShareIcon.propTypes = iconPropTypes;

export default ShareIcon;
